var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-editor',_vm._b({attrs:{"id":"editor","use-custom-image-handler":"","editor-options":_vm.options,"placeholder":_vm.placeholder},on:{"image-added":_vm.handleImageAdded},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}},'vue-editor',_vm.$attrs,false))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afa43772","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/commons/ZmEditor/index.vue
// module id = null
// module chunks = 